import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Row, Col, Container, Image } from 'react-bootstrap'
// Redux Selector / Action
import { useSelector } from 'react-redux';

//image
import logo from '../../../../assets/images/logo.png'
import apple from '../../../../assets/images/getappimg/1.svg'
import android from '../../../../assets/images/getappimg/2.svg'
import Swal from 'sweetalert2';
import { getAuthenticatedDefaultPath } from '../../../../utilities/teacherModulePermissions';

const Footer = (props) => {
    let profileData = (useSelector((state) => state.setting.setting.user_data))
    profileData = profileData ? JSON.parse(profileData) : "";
    const authHomePath = getAuthenticatedDefaultPath(profileData);

    let generalSettingsData = (useSelector((state) => state.setting.setting.general_settings))
    generalSettingsData = generalSettingsData ? JSON.parse(generalSettingsData) : "";

    const navigate = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('dark');
    if (mode !== null) {
        document.body.classList = ''
        switch (mode) {
            case "true":
                document.body.classList = 'dark'
                break;
            case "false":
                document.body.classList = ''
                break;
            default:
                document.body.classList = ''
                break;
        }
    }

    function showLoginAlert() {
        Swal.fire({
            title: 'Warning!',
            text: 'You are not loged in, are you sure you want to login?',
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Go to Login',
            confirmButtonColor: "#5c518b"
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/auth/sign-in')
            }
        })
    }

    function showWarningAlert() {
        Swal.fire({
            title: 'Warning!',
            text: 'Sorry you are not eligible for this features!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
        })
    }


    return (
        <>
            {/* .site-footer gets its sidebar-aware left/right insets from CSS
                (see _footer.scss) instead of the old JS-computed inline width
                — the footer sits as a sibling of .sidebar/.main-content, not
                inside .main-content, so it never got those insets "for free"
                the way the rest of the page does; a leftover 72%-width inline
                style was applied at every width down to 768px even though the
                sidebar is a hidden off-canvas drawer (not a persistent rail)
                below 1200px, which is what squeezed the four columns below
                into an unreadably narrow strip on tablet. The four sections
                also now sit in one real Row/Col grid (1-up on phones, 2-up on
                small/tablet, 4-up at lg+) instead of an unwrapped
                `d-flex justify-content-between`, so they reflow predictably
                instead of force-shrinking. */}
            <footer className="site-footer" style={{ background: "#F5F7FE" }}>
                <Container fluid className='mt-0'>
                    <Row className="mb-1 g-4">
                        <Col xs={12} sm={6} lg={2} className="footer-col">
                            <h4 className="footer-col-title invisible d-none d-sm-flex" aria-hidden="true">.</h4>
                            <div className="d-flex align-items-center gap-3">
                                <Link
                                    to={authHomePath}
                                    className="d-flex align-items-center gap-2 iq-header-logo">
                                    <Image src={logo} className="img-fluid" style={{ width: 130 }} />
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={4} className="footer-col">
                            <h4 className="footer-col-title">OUR ADDRESS</h4>
                            <div>
                                <h5 className="logo-title d-sm-block d-flex align-items-center gap-2">
                                    <i className="material-symbols-outlined text-primary" style={{ fontSize: '20px' }}>phone</i>
                                    <Link>{generalSettingsData?.phone_no}</Link>
                                </h5>
                                <p className="pt-3 pb-1">{generalSettingsData?.address} <br />{generalSettingsData?.email}</p>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} className="footer-col">
                            <h4 className="footer-col-title">QUICK LINK</h4>
                            <div>
                                <Link to="/contact-us">
                                    <h5 className="logo-title d-sm-block mt-2 mb-2 cursor-pointer">Contact Us</h5>
                                </Link>
                                <Link to="/terms-of-use">
                                    <h5 className="logo-title d-sm-block mt-2 mb-2 cursor-pointer">Terms of Use</h5>
                                </Link>
                                <Link to="/privacy-policy">
                                    <h5 className="logo-title d-sm-block mt-2 mb-2 cursor-pointer">Privacy Policy</h5>
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} lg={3} className="footer-col">
                            <h4 className="footer-col-title logo-title d-sm-block uppercase">GET ACCESS FROM ANYWHERE</h4>
                            <div className="mt-2 d-flex flex-wrap align-items-center gap-2">
                                <img src={apple} alt="Download on the Apple Store" className="footer-store-badge" style={{ width: 141, height: 44, objectFit: "fill", cursor: "pointer" }} />
                                <img src={android} alt="Get it on Google Play" className="footer-store-badge" style={{ width: 141, height: 44, objectFit: "fill", cursor: "pointer" }} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.harmonydaycare', '_blank')} />
                            </div>
                        </Col>
                    </Row>
                    <div>
                        <hr />
                        <Row className="mt-3 mb-0">
                            <Col lg="8" >
                                <span>© 2026 Harmony Daycare. All Right Reserved | Powered by <Link to={"https://show.syntch.ai/"} target='_blank noopener,noreferrer' className="text-primary fw-bold">Syntch</Link> | Developed by <Link to={"https://www.debtechllc.com/"} target='_blank noopener,noreferrer' className="text-primary fw-bold">Debtech LLC</Link></span>
                            </Col>
                            <Col lg="4" className="d-flex justify-content-end">
                                {/* <ul className="list-inline mb-0">
                                <li className="list-inline-item"><Link to="/dashboard/extrapages/privacy-policy">Privacy Policy</Link></li>{' '}
                                <li className="list-inline-item"><Link to="/dashboard/extrapages/terms-of-service">Terms of Use</Link></li>
                            </ul> */}
                                <ul className="list-inline mb-0">
                                    {/* <li className="list-inline-item"><h6>Follow Us On </h6></li> */}
                                    <li className="list-inline-item ms-4" style={{ font: "icon" }}><Link to={generalSettingsData?.fb_link} target='_blank noopener,noreferrer'><i className="ri-facebook-fill" /></Link></li>
                                    <li className="list-inline-item ms-4" style={{ font: "icon" }}><Link to={generalSettingsData?.twit_link} target='_blank noopener,noreferrer'><i className="ri-twitter-fill " /></Link></li>
                                    <li className="list-inline-item ms-4" style={{ font: "icon" }}><Link to={generalSettingsData?.insta_link} target='_blank noopener,noreferrer'><i className="ri-instagram-line" /></Link></li>
                                    <li className="list-inline-item ms-4" style={{ font: "icon" }}><Link to={generalSettingsData?.linked_link} target='_blank noopener,noreferrer'><i className="ri-linkedin-fill" /></Link></li>
                                </ul>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </footer>
        </>
    )
}

export default (Footer)